import { render } from "./CustomerInfoBox.vue?vue&type=template&id=381f6a1e&scoped=true"
import script from "./CustomerInfoBox.vue?vue&type=script&lang=js"
export * from "./CustomerInfoBox.vue?vue&type=script&lang=js"

import "./CustomerInfoBox.vue?vue&type=style&index=0&id=381f6a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381f6a1e"]])

export default __exports__